/*
  Sale colors on the product page (snippets/sivana-sale-colors.liquid, styles in assets/sivana-pdp-main.css).
  The swatch app (Platmart) draws every color of the group in one row. Colors the snippet lists as final sale
  and marked down move to the end of that row, after a "Sale colors" label that takes a full line, and show
  their price under the dot. The links stay inside the app's container, so assets/sivana-color-stock.js
  (sold out in this size) and assets/sivana-pdp-premium.js (sold-out note) keep working on them.
  Loaded by sections/sivana-pdp-breadcrumb.liquid.
*/
(() => {
  let data = null;
  try {
    data = JSON.parse(document.querySelector('[data-sivana-sale-colors]')?.textContent || 'null');
  } catch (error) {
    data = null;
  }
  if (!Array.isArray(data) || !data.length) return;
  const prices = new Map(data.map((item) => [item.handle, item.price]));

  const container = () => document.querySelector('.product-information .pl-swatches__container');

  // True once the row is drawn (with or without sale colors in it); false while the app hasn't drawn it yet.
  function apply() {
    const row = container();
    if (!row) return false;
    if (row.querySelector('.sivana-sale-colors__label')) return true;
    const links = [...row.querySelectorAll('.pl-swatches__link[data-handle]')].filter((link) => {
      if (!prices.has(link.dataset.handle)) return false;
      // A sold-out color is hidden by the premium look unless it is the color on the page
      const active = !!link.querySelector('.pl-swatches__swatch-wrapper--active');
      return active || !link.classList.contains('pl-swatches__link--disabled');
    });
    if (!links.length) return true;

    const label = document.createElement('p');
    label.className = 'sivana-sale-colors__label';
    label.textContent = 'Sale colors';
    row.append(label);
    links.forEach((link) => {
      link.setAttribute('data-sivana-sale', '');
      const price = document.createElement('span');
      price.className = 'sivana-sale-colors__price';
      price.textContent = prices.get(link.dataset.handle);
      link.append(price);
      row.append(link);
    });
    return true;
  }

  // The swatch app draws its row after the page loads; wait for it (stop after 10 seconds)
  const begin = () => {
    if (apply()) return;
    const observer = new MutationObserver(() => {
      if (apply()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => observer.disconnect(), 10000);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', begin);
  else begin();
})();
